module.exports = __webpack_public_path__ + "static/media/HUNNY.347c57b8.png";